const CONSENT_READINESS_WAIT_MS = 5 * 60 * 1000

export function getConsentReadinessRemainingMs(
  createdAtTimestamp: string,
  nowMs = Date.now(),
): number {
  const createdAtMs = Date.parse(createdAtTimestamp)
  if (Number.isNaN(createdAtMs)) return 0

  return Math.max(0, createdAtMs + CONSENT_READINESS_WAIT_MS - nowMs)
}

export function formatConsentReadinessTime(remainingMs: number): string {
  const remainingSeconds = Math.max(0, Math.ceil(remainingMs / 1000))
  const minutes = Math.floor(remainingSeconds / 60)
  const seconds = remainingSeconds % 60

  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}
